// Focus rings follow the last real input:
// A mouse, trackpad, pen or touch press hides Focus rings;
// Keyboard brings Focus rings back, including Enter or Space activating a button;
const TEXT_ENTRY =
  'textarea, [contenteditable], input:not([type="button"], [type="submit"], [type="reset"], [type="checkbox"], [type="radio"])'

document.addEventListener('pointerdown', () => {
  document.body.classList.add('hide-global-focus')
})

document.addEventListener('keydown', (e) => {
  const keyCode = e.code?.toUpperCase()
  const navigates = ['TAB', 'ARROWUP', 'ARROWDOWN', 'ESCAPE'].includes(keyCode)
  const activates =
    ['ENTER', 'NUMPADENTER', 'SPACE'].includes(keyCode) && !e.composedPath()[0]?.matches?.(TEXT_ENTRY)

  if (navigates || activates) document.body.classList.remove('hide-global-focus')
})
